import api from '../api';

import { importFetchedStatuses } from './importer';

export const PENDING_MENTIONS_FETCH_REQUEST = 'PENDING_MENTIONS_FETCH_REQUEST';
export const PENDING_MENTIONS_FETCH_SUCCESS = 'PENDING_MENTIONS_FETCH_SUCCESS';
export const PENDING_MENTIONS_FETCH_FAIL = 'PENDING_MENTIONS_FETCH_FAIL';

export function fetchPendingMentions() {
  return (dispatch, getState) => {
    if (getState().getIn(['status_lists', 'pending_mentions', 'isLoading'])) {
      return;
    }

    dispatch({
      type: PENDING_MENTIONS_FETCH_REQUEST,
      skipLoading: true,
    });

    api(getState).get('/api/v1/pending_mentions').then(response => {
      const statuses = response.data.map(item => item.status).filter(Boolean);

      dispatch(importFetchedStatuses(statuses));
      dispatch({
        type: PENDING_MENTIONS_FETCH_SUCCESS,
        statuses,
        skipLoading: true,
      });
    }).catch(error => {
      dispatch({
        type: PENDING_MENTIONS_FETCH_FAIL,
        error,
        skipLoading: true,
      });
    });
  };
}
